const response = {
    isSuccessStatus: (res) => {
        return res.status >= 200 && res.status < 300;
    }
};

export default response;